import { c as r } from "./string-B9G_tJZ-.js";
var n = /* @__PURE__ */ ((e) => (e[e.Mainnet = 1] = "Mainnet", e[e.Goerli = 5] = "Goerli", e[e.Optimism = 10] = "Optimism", e[e.Matic = 137] = "Matic", e[e.Base = 8453] = "Base", e[e.Sepolia = 11155111] = "Sepolia", e))(n || {});
const o = [
  1,
  8453,
  137,
  10
  /* Optimism */
], a = [
  5,
  11155111
  /* Sepolia */
], i = [
  1,
  10,
  137,
  8453,
  11155111
  /* Sepolia */
];
function c(e) {
  const t = r(e);
  return t in n ? n[t] : null;
}
const u = (e) => i.includes(e);
function l(e) {
  if (s(e)) {
    const t = n[e];
    return t.charAt(0).toLowerCase() + t.slice(1);
  }
  throw new Error("Unsupported Network");
}
function p(e) {
  return a.includes(e);
}
function s(e) {
  return Object.values(n).filter((t) => typeof t == "number").includes(e);
}
const f = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MAIN_NETWORKS: o,
  NetworkId: n,
  SUPPORTED_NETWORKS_ARRAY: i,
  TEST_NETWORKS: a,
  getNetworkNameforNetworkId: l,
  isKnownNetworkId: s,
  isSupportedNetwork: u,
  isTestnet: p,
  resolveChainIdByName: c
}, Symbol.toStringTag, { value: "Module" }));
export {
  o as M,
  n as N,
  i as S,
  a as T,
  s as a,
  u as b,
  l as g,
  p as i,
  f as n,
  c as r
};
